module.exports = __webpack_public_path__ + "static/media/S1N1-3.38d3505f.svg";